<template>
  <v-container fluid fill-height dark class="message-container animated fadeInDown">
    <v-layout align-content-center text-center row>
      <v-flex xs12>
        <h2 class="text-h5 font-weight-bold message-title">{{ $t("view.login.sessionExpired.titleFirstPart") }} {{ userName }}{{ $t("view.login.sessionExpired.titleSecondPart") }}</h2>
      </v-flex>
      <v-flex xs12>
        <p class="message-instruction">
          {{ $t("view.login.sessionExpired.instructions") }}
        </p>
      </v-flex>
      <v-flex xs12>
        <div class="sk-spinner sk-spinner-circle message-spinner">
          <div class="sk-circle1 sk-circle" />
          <div class="sk-circle2 sk-circle" />
          <div class="sk-circle3 sk-circle" />
          <div class="sk-circle4 sk-circle" />
          <div class="sk-circle5 sk-circle" />
          <div class="sk-circle6 sk-circle" />
          <div class="sk-circle7 sk-circle" />
          <div class="sk-circle8 sk-circle" />
          <div class="sk-circle9 sk-circle" />
          <div class="sk-circle10 sk-circle" />
          <div class="sk-circle11 sk-circle" />
          <div class="sk-circle12 sk-circle" />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";

export default {
  name: "SessionExpiredMessageModule"
  , data() {
    return { usuario: { username: "" } };
  }
  , head: {
    title: function () {
      return {
        inner: this.$t("view.login.sessionExpired.title")
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    userName() {
      return this.usuario.username;
    }
  }
  , created() {
    if (this.$route.params.username) {
      const { username, nombre } = this.$route.params;
      this.usuario.username = username;
      this.usuario.nombre = nombre;
      this.delayLogOut();
    } else {
      this.$router.push("/401Unauthorized");
    }
  }
  , methods: {
    delayLogOut() {
      setTimeout(this.logOut, 2000);
    }
    , async logOut() {
      try {
        this.$store.dispatch(actions.STOP_ID_SESSION_TIME_INTERVAL);
        await Auth.logOut();
        this.$store.dispatch(actions.AUTH_LOGOUT);
        this.$router.push("/auth");
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container {
  background-color: #2f4050;
}
.message-title {
  margin-bottom: 10px;
  color: white;
}
.message-instruction {
  margin-bottom: 30px;
  color: #c4c4c4;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/SessionExpiredMessage.vue